import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import "./css/stylesheet.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NotFound } from "components/notFound";
import { AboutUs } from "pages/aboutUs";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container!);

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <AboutUs />,
      errorElement: <NotFound />,
    },
    {
      path: "aboutUs",
      element: <AboutUs />,
    },
  ]
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
